import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './FormFooter.styles';

export interface FormFooterProps {
  pending?: boolean;
  isDirty?: boolean;
}

export function FormFooter({ pending, isDirty }: FormFooterProps) {
  const t = useTranslations();

  const slots = styles();

  return (
    <div className={slots.base()}>
      <UiKitButtonBase
        disabled={pending || !isDirty}
        className={slots.button()}
        type="submit"
      >
        {t('submit')}
      </UiKitButtonBase>

      <p className={slots.disclaimer()}>
        {t.rich('form.privacy', {
          buttonText: t('submit'),
          link: (chunks) => (
            <a
              className={slots.link()}
              href="/legal/politika-konfidentsialnosti/"
              target="_blank"
              rel="noreferrer"
            >
              {chunks}
            </a>
          )
        })}
      </p>
    </div>
  );
}
